import { render, staticRenderFns } from "./BookingSummaryPanel.vue?vue&type=template&id=1349325c&scoped=true&"
import script from "./BookingSummaryPanel.vue?vue&type=script&lang=js&"
export * from "./BookingSummaryPanel.vue?vue&type=script&lang=js&"
import style0 from "./BookingSummaryPanel.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./BookingSummaryPanel.vue?vue&type=style&index=1&id=1349325c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1349325c",
  null
  
)

export default component.exports